export const DRIPPING_TIME = {
  YEARS: 5,
  DAYS: 1825
};
